/** @format */

import * as actions from '../actions/gatewayProfileGateways';

const defaultState = {
  filter: {},
  sort: {},
  isLoading: false,
  error: false,
};

export const gatewayProfileGateways = (state = defaultState, action) => {
  switch (action.type) {
    case actions.FETCH_GATEWAY_PROFILE_GATEWAYS_REQUEST:
      return {
        isLoading: true,
        error: false,
      };
    case actions.FETCH_GATEWAY_PROFILE_GATEWAYS_SUCCESS:
      return {
        ...action.payload,
        isLoading: false,
        error: false,
      };
    case actions.FETCH_GATEWAY_PROFILE_GATEWAYS_FAILURE:
      return {
        ...action.payload,
        isLoading: false,
        error: true,
      };

    case actions.DESTROY_GATEWAY_PROFILE_GATEWAYS_SUCCESS:
      return {
        isLoading: false,
        error: false,
      };

    default:
      return state;
  }
};

export const gatewayProfileGatewaysMap = (state = defaultState, action) => {
  switch (action.type) {
    case actions.FETCH_GATEWAY_PROFILE_GATEWAYS_MAP_REQUEST:
      return {
        isLoading: true,
        error: false,
      };
    case actions.FETCH_GATEWAY_PROFILE_GATEWAYS_MAP_SUCCESS:
      return {
        ...action.payload,
        isLoading: false,
        error: false,
      };
    case actions.FETCH_GATEWAY_PROFILE_GATEWAYS_MAP_FAILURE:
      return {
        ...action.payload,
        isLoading: false,
        error: true,
      };

    case actions.DESTROY_GATEWAY_PROFILE_GATEWAYS_MAP_SUCCESS:
      return {
        isLoading: false,
        error: false,
      };

    default:
      return state;
  }
};
